import type { FigmaRestApi } from "@zeytal/types";

import { addQueryParams, getFigmaEndpoint } from "../utils/index.ts";

export const getFigmaVersionsEndpoint = async (
  figmaApiKey: string,
  figmaFileId: string,
  queryParams = "",
) => {
  const endpoint = `https://api.figma.com/v1/files/${figmaFileId}/versions`;
  return getFigmaEndpoint<FigmaRestApi.GetFileVersionsResponse>(
    figmaApiKey,
    addQueryParams(endpoint, queryParams),
  );
};
